/**
*
* TimeGrid
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { format } from 'utils/date-fns/index.js';

const Wrapper = styled.div`
  height: ${(p) => p.height}px;
  overflow: hidden;
  & > *:first-child {
    margin-top: ${(p) => p.top}px;
  }
`;

const Bar = styled.div`
  height: ${(p) => p.height}px;
  border-top: 1px solid ${(p) => p.theme.tableBorderColor};
  & > div {
    width: 45px;
    white-space: nowrap;
    font-size: 12px;
    padding: 0 5px;
    border-right: 1px solid ${(p) => p.theme.tableBorderColor};
    height: 100%;
    color: ${(p) => p.theme.gray};
  }
`;

function TimeGrid(props) {
  const { sizes: { min, max, resolution }, step } = props;
  const mStep = step * 60000;
  const offset = min % mStep;
  const start = min - offset;
  const height = (max - min) * resolution;
  const bars = [];
  for (let t = start; t < max; t += mStep) {
    bars.push(format(t, 'p'));
  }
  return (
    <Wrapper height={height} top={-offset * resolution}>
      {bars.map((t) => <Bar key={t} height={mStep * resolution}><div>{t}</div></Bar>)}
    </Wrapper>
  );
}

TimeGrid.propTypes = {
  sizes: PropTypes.object,
  step: PropTypes.number,
};

export default TimeGrid;
